import * as React from 'react';
import SplitPane from 'react-split-pane';
import debounce = require('lodash/debounce');

import './styles.sass';

export interface ISessionEditorSplitPaneProps {
    hidden: boolean;
    bottomBarHidden: boolean;
    toggleBottomBar: (state?: boolean) => void;
    children?: any;
}
interface ISessionEditorSplitPaneState {
  splitPaneSize: number;
}
const MIN_CONSOLE_HEIGHT = 190; // 5 lines of code
export class SessionEditorSplitPane extends React.Component<ISessionEditorSplitPaneProps, ISessionEditorSplitPaneState> {
  public state = {splitPaneSize: 0};
  private splitPaneDefaultSize: number = 0;
  private splitPaneRef: any = null;
  private onWindowResize: any = debounce((): void => this.setHeight());
  public render(): React.ReactElement<{}> {
    const {children} = this.props;
    return (
      <div className={'session-editor-split-pane'}>
        <SplitPane
          maxSize={0}
          split={'horizontal'}
          size={this.state.splitPaneSize}
          ref={(node) => this.splitPaneRef = node}
          onChange={this.onSplitPaneChange}
        >
          {children}
        </SplitPane>
      </div>
    );
  }
  public componentDidMount(): void {
    this.splitPaneDefaultSize = this.calculateSplitPaneSize();
    window.addEventListener('resize', this.onWindowResize);
    this.toggleBottomBar();
  }
  public componentWillUnmount(): void {
    window.removeEventListener('resize', this.onWindowResize);
  }
  public componentDidUpdate(prevProps: ISessionEditorSplitPaneProps): void {
      const didChangeToVisible = !this.props.hidden && prevProps.hidden !== this.props.hidden;

      // splitPaneDefaultSize would have been 0 when we were hidden
      if (didChangeToVisible) {
          this.splitPaneDefaultSize = this.calculateSplitPaneSize();
      }

      if (didChangeToVisible || (this.props.bottomBarHidden !== prevProps.bottomBarHidden)) {
          this.toggleBottomBar();
      }
  }
  private toggleBottomBar = (): void => {
    this.props.bottomBarHidden ? this.hideBottomBar() : this.showBottomBar();
  }
  private showBottomBar = (): void => {
    this.setState({splitPaneSize: Math.min(0.75 * this.splitPaneDefaultSize, this.splitPaneDefaultSize - MIN_CONSOLE_HEIGHT)});
  }
  private hideBottomBar = (): void => {
    this.setState({splitPaneSize: this.splitPaneDefaultSize});
  }
  /**
   * handles pane resize
   */
  private onSplitPaneChange = (size: number): void => {
    const {bottomBarHidden, toggleBottomBar} = this.props;
    if (size === this.splitPaneDefaultSize) {
      bottomBarHidden || toggleBottomBar(true);
    } else {
      bottomBarHidden && toggleBottomBar(false);
    }
  };
  /**
   * Handles window resize
   */
  private setHeight = () => {
    const {bottomBarHidden, toggleBottomBar} = this.props;
    if (!bottomBarHidden && this.state.splitPaneSize < MIN_CONSOLE_HEIGHT) {
      return toggleBottomBar(true);
    }
    const draggedSize = this.splitPaneRef.state.draggedSize;
    if (typeof draggedSize === 'number' && !isNaN(draggedSize)) {
      const currentSplitPaneSize = this.calculateSplitPaneSize();
      const splitPaneSize = Math.round(draggedSize / this.splitPaneDefaultSize * currentSplitPaneSize);
      this.setState({splitPaneSize}, () => this.splitPaneDefaultSize = currentSplitPaneSize);
    }
  };
  private calculateSplitPaneSize = (): number => {
    return this.splitPaneRef.splitPane.getBoundingClientRect().height;
  }
}
